import { useEffect, useState } from "react";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const useReferralCode = ({ token, workerType }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const generate = async () => {
      if (!workerType) {
        setError("Missing worker details");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const response = await axios.post(
          `${BASE_URL}/referral-sourcing/referral-codes/generate`,
          { worker_type: workerType },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        setData(response.data || null);
      } catch (err) {
        console.error("Failed to generate referral code:", err);
        setError("Failed to load referral details");
      } finally {
        setLoading(false);
      }
    };

    generate();
  }, [workerType, token]);

  return {
    loading,
    error,
    referralCode: data?.referralCode?.referrer_code,
    referrerName: data?.referralCode?.referrer_name || "",
    amount: data?.Amount,
    referralLink: data?.qrLink || "",
    howItWorks: Array.isArray(data?.howItWorks) ? data.howItWorks : [],
    raw: data,
  };
};